var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {},
    [
      _c(
        "el-popover",
        {
          ref: "treePopover",
          attrs: {
            placement: "bottom-start",
            trigger: "manual",
            "popper-class": "popover",
          },
          model: {
            value: _vm.showPopover,
            callback: function ($$v) {
              _vm.showPopover = $$v
            },
            expression: "showPopover",
          },
        },
        [
          _c(
            "div",
            { staticClass: "tree-box", attrs: { id: "treePopover" } },
            [
              _c(
                "div",
                { staticClass: "input" },
                [
                  _c("el-input", {
                    attrs: {
                      size: "small",
                      "prefix-icon": "el-icon-search",
                      placeholder: "请输入标签搜索",
                    },
                    model: {
                      value: _vm.filterText,
                      callback: function ($$v) {
                        _vm.filterText = $$v
                      },
                      expression: "filterText",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("el-tree", {
                ref: "tree",
                attrs: {
                  "highlight-current": "",
                  props: _vm.props,
                  indent: 4,
                  data: _vm.treeData,
                  "node-key": "id",
                  "filter-node-method": _vm.filterNode,
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var node = ref.node
                      var data = ref.data
                      return _c(
                        "div",
                        {
                          staticClass: "custom-tree-node",
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.selectFn(node, data)
                            },
                          },
                        },
                        [
                          _c("div", { staticClass: "flex-box" }, [
                            _c(
                              "span",
                              {
                                staticClass: "over-text",
                                class: {
                                  isChecked: _vm.labelIds.includes(
                                    data[_vm.valType]
                                  ),
                                },
                                attrs: {
                                  "default-expanded-keys": _vm.treeExpandData,
                                },
                              },
                              [_vm._v(_vm._s(node.label))]
                            ),
                            _vm._v(" "),
                            data.pid == 0
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "all-text",
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.selectAllFn(node, data)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.allIds.includes(data[_vm.valType])
                                          ? "取消全选"
                                          : "全选"
                                      )
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            data.pid != 0 &&
                            _vm.labelIds.includes(data[_vm.valType])
                              ? _c("span", { staticClass: "el-icon-check" })
                              : _vm._e(),
                          ]),
                        ]
                      )
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "template",
            { slot: "reference" },
            [
              _vm._t("custom"),
              _vm._v(" "),
              !_vm.isSlots && !_vm.slotType
                ? _c(
                    "div",
                    {
                      ref: "select",
                      staticClass: "select plan-footer-one mr10",
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.handlePopoverShow($event)
                        },
                      },
                    },
                    [
                      _vm.selectList && _vm.selectList.length == 0
                        ? _c("span", { staticClass: "placeholder" }, [
                            _vm._v(_vm._s(_vm.placeholder)),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.selectList.length > 0 && !_vm.isSearch
                        ? _c(
                            "div",
                            _vm._l(_vm.selectList, function (item, index) {
                              return _c(
                                "span",
                                {
                                  key: index,
                                  staticClass:
                                    "el-tag el-tag--small el-tag--info el-tag--light mr10",
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(item.name) +
                                      "\n            "
                                  ),
                                  _c("i", {
                                    staticClass: "el-tag__close el-icon-close",
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.cardTag(
                                          index,
                                          item[_vm.valType]
                                        )
                                      },
                                    },
                                  }),
                                ]
                              )
                            }),
                            0
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.selectList.length > 0 && _vm.isSearch
                        ? _c("div", { staticClass: "flex-box" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "el-tag el-tag--small el-tag--info el-tag--light mr10 lh-center",
                                staticStyle: { width: "100px" },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                  },
                                },
                              },
                              [
                                _c("span", { staticClass: "line1" }, [
                                  _vm._v(" " + _vm._s(_vm.selectList[0].name)),
                                ]),
                                _vm._v(" "),
                                _c("span", {
                                  staticClass: "el-tag__close el-icon-close",
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.cardTag(
                                        0,
                                        _vm.selectList[0][_vm.valType]
                                      )
                                    },
                                  },
                                }),
                              ]
                            ),
                            _vm._v(" "),
                            _vm.selectList.length > 1
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "el-tag el-tag--small el-tag--info el-tag--light mr10",
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(_vm.selectList.length - 1) +
                                        "\n          "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ])
                        : _vm._e(),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.slotType == "customer"
                ? _c(
                    "div",
                    {
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.handlePopoverShow($event)
                        },
                      },
                    },
                    [_vm._v("设置标签")]
                  )
                : _vm._e(),
            ],
            2
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }